// extracted by mini-css-extract-plugin
export default {"actions":"ListWrapper_actions__IpNRL","edit":"ListWrapper_edit__erO8h","delete":"ListWrapper_delete__3l9C0"};